
<template>
  <el-form
    label-position="right"
    :label-width="labelWidth"
    inline
    class="demo-table-expand"
  >
    <el-form-item
      v-for="item, index in data"
      :key="index"
      :label="t(item.label)"
      style="width: 45%"
    >
      <img
        v-if="item.img"
        :src="item.value"
        alt=""
        style="object-fit: contain;max-width:200px; max-height: 100px"
      >
      <span v-else>{{ item.value }}</span>
    </el-form-item>
  </el-form>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
export default defineComponent({
  props: {
    labelWidth: {
      type: String,
      default: '150px'
    },
    data: {
      type: Array,
      default: () => [] as any
    }
  },
  setup() {
    const { t } = useI18n()
    return { t }
  }
})
</script>
